import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { useLanguage } from "@/i18n";
import SectionHead, { EASE, reveal } from "@/components/SectionHead";

export default function Clients() {
  const { t } = useLanguage();

  return (
    <section id="clients" className="relative py-28 sm:py-32" data-testid="clients-section">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-400/40 to-transparent" />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead eyebrow={t.clients.eyebrow} title={t.clients.h2} body={t.clients.body} testid="clients-title" />

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {t.clients.groups.map((group, gi) => (
            <motion.div
              key={group.label}
              {...reveal}
              transition={{ duration: 0.75, delay: gi * 0.1, ease: EASE }}
              data-testid={`clients-group-${gi + 1}`}
              className="flex h-full flex-col overflow-hidden rounded-2xl border border-slate-800/60 bg-slate-900/40 p-8 backdrop-blur-sm transition-all duration-500 hover:-translate-y-1 hover:border-orange-400/40 hover:shadow-[0_16px_50px_rgba(234,88,12,0.14)]"
            >
              <p className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-orange-400">
                <span className="h-px w-6 bg-orange-400" />
                {group.label}
              </p>
              <ul className="mt-6 flex-1 space-y-1">
                {group.items.map((item, i) => (
                  <li
                    key={i}
                    className="group/row flex items-center justify-between gap-4 rounded-xl px-3 py-3.5 transition-colors duration-300 hover:bg-slate-800/40"
                    data-testid={`client-row-${gi + 1}-${i + 1}`}
                  >
                    <div>
                      <div className="text-sm font-semibold text-slate-100 transition-colors group-hover/row:text-orange-200">
                        {item.name}
                      </div>
                      <div className="mt-0.5 flex items-center gap-1.5 text-xs text-slate-500">
                        <MapPin className="h-3 w-3" />
                        {item.loc}
                      </div>
                    </div>
                    <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gradient-to-r from-orange-400 to-amber-400 opacity-40 transition-opacity duration-300 group-hover/row:opacity-100" />
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
